import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { gettotalOffers } from "../../store/totaloffer/totaloffAction";
import { Link } from "react-router-dom";
import { baseUrl } from "../../utils/APi";
import { LazyLoadImage } from "react-lazy-load-image-component";
const Counter = () => {
  const dispatch = useDispatch();
  const lan = useSelector((state) => state.LanSlicer.language);
  const { offers } = useSelector((state) => state.Offers);

  useEffect(() => {
    if (offers?.length === 0) {
      const promise = dispatch(gettotalOffers(lan));
      return () => {
        promise.abort();
      };
    }
  }, [lan, dispatch, offers?.length]);

  return (
    <section className="flat-counter">
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <div
              className="counter-box themesflat-counter hover-up wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <div className="icon-box">
                <div className="icon-counter">
                  <span className="icon-guarantee1"></span>
                </div>
                <div className="content-icon">
                  <h3 className="section-20px-montserrat font-weight-600 line-height-35">
                    Projects
                    <br />
                    With 100% satisfaction
                  </h3>
                </div>
              </div>
              <div className="number-content section-65px-montserrat">
                <span
                  className="number"
                  data-speed="2000"
                  data-to="250"
                  data-inviewport="yes"
                >
                  250
                </span>
                K
              </div>
              <p>Power of choices when nothing what we like best principle</p>
            </div>
          </div>
          <div className="col-md-4">
            <div
              className="counter-box themesflat-counter hover-up wow fadeInUp"
              data-wow-delay="0.4s"
            >
              <div className="icon-box">
                <div className="icon-counter">
                  <span className="icon-support1"></span>
                </div>
                <div className="content-icon">
                  <h3 className="section-20px-montserrat font-weight-600 line-height-35">
                    Experienced &<br />
                    Professional team
                  </h3>
                </div>
              </div>
              <h2 className="number-content section-65px-montserrat">
                <span
                  className="number"
                  data-speed="2000"
                  data-to="138"
                  data-inviewport="yes"
                >
                  138
                </span>
                +
              </h2>
              <p>
                Except to obtain some of advantages from it has any right to
                find.
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div
              className="counter-box themesflat-counter1 hover-up wow fadeInUp"
              data-wow-delay="0.8s"
            >
              <div className="icon-box">
                <div className="icon-counter">
                  <span className="icon-guarantee"></span>
                </div>
                <div className="content-icon">
                  <h3 className="section-20px-montserrat font-weight-600 line-height-35">
                    Projects
                    <br />
                    With 100% satisfaction
                  </h3>
                </div>
              </div>
              <h2 className="number-content section-65px-montserrat">
                <span
                  className="number"
                  data-speed="2000"
                  data-to="150"
                  data-inviewport="yes"
                >
                  150
                </span>
                K
              </h2>
              <p>Power of choices when nothing what we like best principle</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Counter;
